var params;

if(window.google && google.maps) {
	initializeMap();
} else {
	lazyLoadGoogleMap();
}


// 01. googlemap
//------------------------------------------------------------------------------------------

function lazyLoadGoogleMap(){

  (function(document, tag) {
      var scriptTag = document.createElement(tag), // create a script tag
          firstScriptTag = document.getElementsByTagName(tag)[0]; // find the first script tag in the document
      scriptTag.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBaQDkEqX78CDqQrY23Go2drlXO7R7c8j0&callback=initializeMap'; // set the source of the script to your script
      firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag); // append the script to the DOM
  }(document, 'script'));

}

function initialize(params){
  var map = document.querySelector('.map-canvas'); // If nly one exists per page
	var id = map.getAttribute('id');
	var lat = map.getAttribute('data-lat');
	var lng = map.getAttribute('data-lng');
	var scale = map.getAttribute('data-zoom');
	googlemap(id, lat, lng, scale);
}

function initializeMap(){
	initialize(params);
}

function googlemap(id, lat, lng, scale){

	var Latlng = new google.maps.LatLng(lat,lng);

	scale = (scale !== null) ?  parseInt(scale) : 13;

	var Options = {
	  zoom: scale,
	  center: Latlng,
	  mapTypeId: google.maps.MapTypeId.ROADMAP,
	  disableDefaultUI: true,
	  draggable: true,
	  zoomControl: true,
	  scrollwheel: false,
	  disableDoubleClickZoom: true,
	};

	var map = new google.maps.Map(document.getElementById(id),Options);

	var hq = new google.maps.Marker({
		position: Latlng,
		map: map,
		animation: google.maps.Animation.DROP
	});


}
